/**
 * 系统管理 菜单管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>菜单管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
    <el-row>
      <!-- title -->
      <div class="modt-box">菜单配置</div>
      <el-col :span="4"> </el-col>
      <el-col :span="6" >
        <div style="height:600px">
          <div class="mod-btnbox">
            <el-button size="small" type="primary" icon="el-icon-plus" @click="addModuleClick(0)">添加根节点</el-button>
            <!-- <el-button size="small" type="primary">全部展开</el-button>
            <el-button size="small" type="primary">全部压缩</el-button> -->
          </div>
          <el-popover
          placement="top"
          width="360"
          v-model="visible">
          <div style="text-align: right; margin: 0">
            <el-button type="primary" size="mini" @click="addModuleClick(parentId)">添加子节点</el-button>
            <el-button type="primary" size="mini" @click="visible = false  , editModuleFlag = true">编辑节点</el-button>
            <el-button size="primary" type="mini" @click="visible = false">取消</el-button>
          </div>
        </el-popover>
        <el-tree class="treeclass"
          style="height:600px"
          ref="tree" 
          accordion
          :data="treeData" 
          :props="defaultProps"
          @node-click="nodeclick" 
          @check-change="handleClick" 
          check-strictly
          @node-contextmenu="contextmenuChange"
          node-key="id"></el-tree>
          </div>
      </el-col>
    </el-row>

    <el-dialog
      :visible.sync="editModuleFlag"
      width="40%">
      <el-form ref="form" :model="form" label-width="180px" :rules="rules">
          <el-form-item label="父级菜单" prop="parentId">
            <el-input size="small" disabled="" v-model="form.parentId"></el-input>
          </el-form-item>
          <el-form-item label="菜单名称" prop="name">
            <el-input size="small" v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="URL" prop="uri">
            <el-input size="small" v-model="form.uri"></el-input>
          </el-form-item>
          <el-form-item label="顺序" prop="num">
            <el-input size="small" v-model="form.num"></el-input>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-radio-group v-model="form.status">
              <el-radio :label="0">禁用</el-radio>
              <el-radio :label="1">启用</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="danger" v-preventReClick v-show="form.id" @click="deleteModule">删除</el-button>
            <el-button size="small" type="primary" v-preventReClick v-show="form.id" @click="saveModule('form')">保存</el-button>
            <el-button size="small" type="primary" v-preventReClick  @click="editModuleFlag = false">关闭</el-button>
            
          </el-form-item>
        </el-form>
        <!-- <div style="display:flex; justify-content:flex-end">
            <el-button type="primary" v-preventReClick @click="addSubmit('addform')">保存</el-button>
            <el-button  @click="addModuleFlag = false">关闭</el-button>
        </div> -->
    </el-dialog>


    <el-dialog
      :visible.sync="addModuleFlag"
      width="40%">
      <el-form ref="addform" :model="addform" label-width="180px" :rules="rules">
          <el-form-item label="父级菜单" prop="parentId">
            <el-input size="small" disabled="" v-model="addform.parentId"></el-input>
          </el-form-item>
          <el-form-item label="父级菜单名称" >
            <el-input size="small" disabled="" v-model="addform.parentName"></el-input>
          </el-form-item>
          <el-form-item label="菜单名称" prop="name">
            <el-input size="small" v-model="addform.name"></el-input>
          </el-form-item>
          <el-form-item label="URL" prop="uri">
            <el-input size="small" v-model="addform.uri"></el-input>
          </el-form-item>
          <el-form-item label="顺序" prop="num">
            <el-input size="small" v-model="addform.num"></el-input>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-radio-group v-model="addform.status">
              <el-radio :label="0">禁用</el-radio>
              <el-radio :label="1">启用</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <div style="display:flex; justify-content:flex-end">
            <el-button type="primary" v-preventReClick @click="addSubmit('addform')">保存</el-button>
            <el-button  @click="addModuleFlag = false">关闭</el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  createMenu,
  ModuleList,
  ModuleGet,
  ModuleNodes,
  ModuleSave,
  ModuleDelete,
  loadMenuList,
  deleteMenu,
  updateMenu
} from '../../api/userMG'
export default {
  data() {
    return {
      addModuleFlag:false,
      showdelete: false,
      treeData:  [
        
      ],
      defaultProps: {
        children: 'childMenusList',
        label: 'name'
      },
      addform:{
        parentId: '0',
        name:'',
        uri:'',
        num:'',
        status:1
      },
      form: {
        parentId: '',
        name:'',
        uri:'',
        num:'',
        status:1
      },
      // rules表单验证
      rules: {
        parentId: [
          { required: true, message: '请选择父级菜单', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入菜单名称', trigger: 'blur' }
        ],
        uri: [{ required: true, message: '请输入URL', trigger: 'blur' }],
        num : [
          { required: true, message: '请输入菜单顺序', trigger: 'blur' }
        ],
        // status:[
        //   { required: true, message: '请输入菜单顺序', trigger: 'blur' }
        // ]
      },
      fmenu: [],
      visible:false,
      parentId:'',
      parentName:'',
      parentForm:{},
      editModuleFlag:false,
    }
  },
  /**
   * 创建完毕
   */

  created() {
    this.getdata()
    // this.getmenu()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    addModuleClick(parentId){
      this.addform = {
        parentId: parentId,
        parentName:parentId == 0?'根节点':this.parentName,
        name:'',
        uri:'',
        num:'',
        status:1
      }
      this.visible = false
      this.addModuleFlag = true
    },
    // 获取数据
    getdata() {
      loadMenuList().then(res=>{
        this.treeData = res.menus
      })
    },
    // 添加
    addModule() {
      this.showdelete = false
      this.form.parentId = '0'
      this.form.status = true
    },
    // 获取父级菜单
    getmenu() {
      let parm = {
        page: '1',
        limit: '10'
      }
      ModuleNodes(parm)
        .then(res => {
          this.fmenu = res.data
        })
        .catch(err => {
          this.loading = false
          this.$message.error('父级菜单列表获取失败，请稍后再试！')
        })
    },
    // 复选变单选
    handleClick(data, checked, node) {
      if (checked) {
        this.$refs.tree.setCheckedNodes([])
        this.$refs.tree.setCheckedNodes([data])
        this.showdelete = true
      } else {
      }
    },
    contextmenuChange(e , arr){
      console.log(arr)
      this.parentId = arr.id
      this.parentName = arr.name
      this.form = arr
      this.visible = true
    },
    // 点击节点
    nodeclick(arr, node, self) {
      console.log(arr)
      this.form = arr
      this.addform.parentId = arr.id
      // ModuleGet(arr.id)
      //   .then(res => {
      //     console.log(JSON.stringify(res))
      //     this.form = res.data.data
      //     this.$refs.tree.setCheckedNodes([])
      //     this.$refs.tree.setCheckedNodes([arr])
      //   })
      //   .catch(err => {
      //     this.loading = false
      //     this.$message.error('用户管理获取失败，请稍后再试！')
      // })
    },
    addSubmit(form){
      this.$refs[form].validate(valid => {
        if (valid) {
          let data = JSON.parse(JSON.stringify(this.addform))
          createMenu(data)
            .then(res => {
              if(!res.success){
                this.$message.error(res.messages)
              }else {
                this.$message.success(res.messages)
              }
              this.getdata()
              this.addModuleFlag = false
              this.addform= {
                parentId: '0',
                name:'',
                uri:'',
                num:'',
                status:1
              }
              // this.getmenu()
            })
            .catch(err => {
              this.$message.error(err.messages)
            })
        } else {
          return false
        }
      })
    },
    // 保存菜单
    saveModule(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          updateMenu({
            id:this.form.id,
            parentId:this.form.parentId,
            name :this.form.name,
            num :this.form.num,
            uri:this.form.uri,
            status:this.form.status
          }).then(res => {
              if(!res.success){
                this.$message.error(res.messages)
              }else {
                this.$message.success(res.messages)
              }
              this.getdata()
              this.addModuleFlag = false
              this.addform= {
                parentId: '0',
                name:'',
                uri:'',
                num:'',
                status:1
              }
              // this.getmenu()
            })
            .catch(err => {
              this.$message.error(err.messages)
            })
        } else {
          return false
        }
      })
    },
    // 删除菜单
    deleteModule() {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteMenu({id:this.form.id})
            .then(res => {
              if (res.success) {
                this.getdata()
                this.$message.error('菜单管理列表删除成功！')
                this.editModuleFlag = false
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('菜单管理列表删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    }
  }
}
</script>

<style>
.user-search {
  margin-top: 20px !important;
}
.user-search td {
  margin-top: 20px !important;
}
.userRole {
  width: 100%;
}
.el-table__expanded-cell {
  padding: 0px !important;
  margin: 0px !important;
}
.modt-box {
  width: 100%;
  height: 60px;
  line-height: 60px;
  background-color: #f0f2f5;
  text-align: center;
  color: #334157;
  margin-top: 20px;
  margin-bottom: 20px;
  font-size: 24px;
}
.mod-btnbox {
  margin-bottom: 20px;
}
.treeclass {
  border: 1px solid #f3f3f3;
  padding-top: 20px;
  padding-bottom: 20px;
}
.selectw {
  width: 100%;
}
</style>
 
 


// WEBPACK FOOTER //
// src/views/system/Module.vue